import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";

import SearchBox from "../../common/components/SearchBox";
import {
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  CircularProgress,
  IconButton,
  Badge,
  Divider,
  TextField,
  Tooltip,
} from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { CardContent, Toolbar } from "@mui/material";
import { useHistory } from "react-router-dom";
import {
  getScholarshipCombinations,
  getScholarshipCourses,
  getScholarshipDocuments,
  getScholarshipRequests,
  deleteScholarshipRequest,
  approveOrRejectScholarshipRequest,
  getEligibility,
  executeScholarshipAlgorithm,
  getScholarshipSchedule,
  getScholarshipRequestLogs,
  submitScholarshipAppeal,
  checkScholarshipAppeal,
  getScholarshipAppealSettings,
} from "../../../../store/scholarship/actions";

import { getDistricts } from "../../../../store/posts/actions";

import ReactPaginate from "react-paginate";
import moment from "moment";
import AddOrUpdateScholarshipRequestDialog from "../components/AddOrUpdateScholarshipRequestDialog";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import AlertDialog from "../../common/components/AlertDialog";
import PreviewTeacherProfile from "../components/PreviewTeacherProfile";
import PreviewScholarshipRequestDialog from "../components/PreviewScholarshipRequestDialog";
import { CSVLink } from "react-csv";
import axios from "axios";
import ScholarshipSummaryDialog from "../components/ScholarshipSummaryDialog";
import ScholarshipCriteriaDialog from "../components/ScholarshipCriteriaDialog";
import { useRequiredAuth } from "../../common/guard/requiredAuth";

function calculateTimeLeft(scholarshipSchedule) {
  const year = new Date().getFullYear();
  const deadLine = !!scholarshipSchedule
    ? new Date(moment(scholarshipSchedule.endOn).format("yyyy-MM-DD"))
    : new Date(moment().format("yyyy-MM-DD"));

  deadLine.setDate(deadLine.getDate() + 1);
  deadLine.setHours(deadLine.getHours() - 1);

  const toDay = new Date();

  const difference = +deadLine - +toDay;

  let timeLeft = {};

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  return timeLeft;
}

function isAppealWindowOpen(scholarshipAppealSettings) {
  return (
    !!scholarshipAppealSettings &&
    !!scholarshipAppealSettings.enabled &&
    !!scholarshipAppealSettings.openedOn &&
    moment().diff(moment(scholarshipAppealSettings.openedOn), "days") <=
      scholarshipAppealSettings.windowDays
  );
}

const Scholarships = (props) => {
  useEffect(() => {
    document.title = "TMIS | Scholarships";
  }, []);

  const { hasPermissions } = useRequiredAuth();

  const {
    user,
    loading,
    env,

    scholarshipCombinations,
    scholarshipCourses,
    scholarshipDocuments,

    getScholarshipCombinations,
    getScholarshipCourses,
    getScholarshipDocuments,

    scholarshipRequests,
    getScholarshipRequests,

    deleteScholarshipRequest,
    approveOrRejectScholarshipRequest,

    districts,
    getDistricts,

    getEligibility,
    executeScholarshipAlgorithm,
    scholarshipSchedule,

    getScholarshipSchedule,
    getScholarshipAppealSettings,
  } = props;

  useEffect(() => {
    if (!scholarshipCombinations.length) getScholarshipCombinations();

    if (!scholarshipCourses.length) getScholarshipCourses();

    if (!scholarshipDocuments.length) getScholarshipDocuments();

    if (!districts.length) getDistricts();

    getEligibility();

    getScholarshipAppealSettings();
  }, []);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecods, setTotalRecods] = useState(0);
  const [loader, setLoader] = useState(false);

  const [itemPerPage, setItemPerPage] = useState(
    window.localStorage.getItem("ITEM_PER_PAGE")
      ? +window.localStorage.getItem("ITEM_PER_PAGE")
      : 10
  );

  useEffect(() => {
    const _currentPage = 1;
    setCurrentPage(_currentPage);

    const _searchTerm = "";
    setSearchTerm(_searchTerm);

    const query = {
      searchTerm: _searchTerm,
      page: _currentPage,
      size: itemPerPage,
    };
    getScholarshipRequests(query, setTotalRecods, setLoader);

    getScholarshipSchedule();
  }, [user.selectedEntity, user.selectedAcademicYear]);

  const onSearch = (term) => {
    setSearchTerm(term);

    if (term === "") {
      const _currentPage = 1;
      setCurrentPage(_currentPage);

      const _searchTerm = "";
      setSearchTerm(_searchTerm);

      const query = {
        searchTerm: _searchTerm,
        page: _currentPage,
        size: itemPerPage,
      };
      getScholarshipRequests(query, setTotalRecods, setLoader);
    }
  };

  const handlePageClick = ({ selected }) => {
    const currentPage = selected + 1;
    setCurrentPage(currentPage);

    const query = {
      searchTerm: searchTerm,
      page: currentPage,
      size: itemPerPage,
    };

    getScholarshipRequests(query, setTotalRecods, setLoader);
  };

  const [showFormDialog, setShowFormDialog] = useState(false);

  const [downloadbleData, setDownloadbleData] = useState([]);

  const dispatch = useDispatch();

  const getDownloadbleData = async () => {
    try {
      setDownloadbleData([]);

      dispatch({ type: "START_LOADING" });

      const { data } = await axios.get("/api/scholarship/all-requests");

      dispatch({ type: "END_LOADING" });

      setDownloadbleData(data);
    } catch (error) {
      dispatch({ type: "END_LOADING" });
    }
  };

  useEffect(() => {
    if (!!downloadbleData.length)
      document.getElementById("downloadBTN").click();
  }, [downloadbleData]);

  const [confirmExecute, setConfirmExecute] = useState(false);
  const [showScholarshipSummary, setShowScholarshipSummary] = useState(false);

  const [timeLeft, setTimeLeft] = useState(
    calculateTimeLeft(scholarshipSchedule)
  );

  useEffect(() => {
    const id = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(scholarshipSchedule));
    }, 1000);

    return () => {
      clearTimeout(id);
    };
  });

  const timerComponents = Object.keys(timeLeft).map((interval, index) => {
    if (!timeLeft[interval]) {
      <span key={index}>00</span>;
    }

    return (
      <span key={index}>
        {timeLeft[interval].toString().padStart(2, "0")}
        {index + 1 < Object.keys(timeLeft).length && <>:</>}
      </span>
    );
  });

  return (
    <>
      <div className="px-4 pt-2">
        <div className="border rounded">
          <AppBar position="static" elevation={0} className="app-bar w-100">
            <Toolbar
              style={{
                minHeight: "0px",
                borderBottom: "3px solid #e9ecef",
              }}
              className=" my-0 py-1 bg-light"
            >
              <Typography
                variant="p"
                noWrap
                component="div"
                className="d-flex  align-items-center text-uppercase text-primary font-weight-bold"
              >
                <span className="text-dark">({totalRecods}) Applications</span>

                <CSVLink
                  data={downloadbleData}
                  filename={`Scholarship requests - ${
                    user?.selectedEntity?.name || user?.selectedEntity?.name
                  }.csv`}
                  className="hidden"
                  id="downloadBTN"
                  target="_blank"
                />
                {hasPermissions(["SCHOLARSHIPS_DOWNLOAD_EXCEL_FILE"]) && (
                  <Tooltip title="Download">
                    <span className="ml-2">
                      <IconButton
                        size="small"
                        disabled={loading || !scholarshipRequests.length}
                        className=" mr-1"
                        color="primary"
                        onClick={() => getDownloadbleData()}
                      >
                        <span className="material-icons">file_download</span>
                      </IconButton>
                    </span>
                  </Tooltip>
                )}

                {hasPermissions(["SCHOLARSHIPS_APPLY"]) && (
                  <Button
                    className="ml-2"
                    disabled={
                      loading ||
                      !(
                        !!scholarshipSchedule &&
                        moment(scholarshipSchedule.startOn).format(
                          "yyyy-MM-DD"
                        ) <= moment().format("yyyy-MM-DD") &&
                        moment(scholarshipSchedule.endOn).format(
                          "yyyy-MM-DD"
                        ) >= moment().format("yyyy-MM-DD")
                      )
                    }
                    onClick={() => {
                      setShowFormDialog(true);
                    }}
                    variant="contained"
                    size="small"
                    disableElevation
                    color="primary"
                    style={{
                      borderRadius: "8px",
                      height: "32px",
                      alignItems: "center",
                      fontSize: ".75rem",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      textTransform: "initial",
                    }}
                  >
                    <span className="material-icons">add</span>
                    Apply for scholarship
                  </Button>
                )}
              </Typography>

              {hasPermissions(["SCHOLARSHIPS_EXECUTE"]) && (
                <Button
                  className="ml-2"
                  onClick={() => setConfirmExecute(true)}
                  disabled={loading || !scholarshipRequests.length}
                  variant="contained"
                  size="small"
                  disableElevation
                  color="inherit"
                  style={{
                    borderRadius: "8px",
                    height: "30px",
                    alignItems: "center",
                    fontSize: ".75rem",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    textTransform: "initial",
                  }}
                >
                  <span className="material-icons">terminal</span>
                  Execute
                </Button>
              )}

              <Box sx={{ display: { xs: "flex", md: "flex" } }}>
                {!!scholarshipSchedule &&
                  moment(scholarshipSchedule.startOn).format("yyyy-MM-DD") <=
                    moment().format("yyyy-MM-DD") &&
                  moment(scholarshipSchedule.endOn).format("yyyy-MM-DD") >=
                    moment().format("yyyy-MM-DD") && (
                    <span
                      className="font-weight-bold ml-2"
                      style={{ color: "#ed6c02" }}
                    >
                      {timerComponents.length ? (
                        timerComponents
                      ) : (
                        <span
                          className={`badge badge-danger ml-2`}
                          style={{ cursor: "default" }}
                        >
                          <i className="fas fa-lock mr-1"></i> CLOSED
                        </span>
                      )}
                    </span>
                  )}

                {!(
                  !!scholarshipSchedule &&
                  moment(scholarshipSchedule.startOn).format("yyyy-MM-DD") <=
                    moment().format("yyyy-MM-DD") &&
                  moment(scholarshipSchedule.endOn).format("yyyy-MM-DD") >=
                    moment().format("yyyy-MM-DD")
                ) && (
                  <span
                    className={`badge badge-danger ml-2`}
                    style={{ cursor: "default" }}
                  >
                    <span>
                      {!scholarshipSchedule ||
                      (!!scholarshipSchedule &&
                        moment(scholarshipSchedule.endOn).format("yyyy-MM-DD") <
                          moment().format("yyyy-MM-DD")) ? (
                        <i className="fas fa-lock mr-1"></i>
                      ) : (
                        <i className="fas fa-clock mr-1"></i>
                      )}

                      {!scholarshipSchedule ||
                      (!!scholarshipSchedule &&
                        moment(scholarshipSchedule.endOn).format("yyyy-MM-DD") <
                          moment().format("yyyy-MM-DD"))
                        ? "CLOSED"
                        : `Will start on ${moment(
                            scholarshipSchedule.startOn
                          ).format("ll")}`}
                    </span>
                  </span>
                )}
              </Box>

              <Box sx={{ flexGrow: 1 }} />

              <>
                {!!scholarshipSchedule?.published && (
                  <span className="d-inline-flex align-items-center mr-2 text-success badge badge-pill">
                    <span className="material-icons ">task_alt</span>
                    Published
                  </span>
                )}

                {hasPermissions(["SCHOLARSHIPS_VIEW_SUMMARY"]) && (
                  <Button
                    size="small"
                    className="mr-2"
                    disabled={
                      loading ||
                      !!showScholarshipSummary ||
                      !scholarshipRequests.length
                    }
                    onClick={() => {
                      setShowScholarshipSummary(true);
                    }}
                    variant="contained"
                    disableElevation
                    color="primary"
                  >
                    <span className="material-icons">summarize</span>
                    Summary
                  </Button>
                )}
              </>

              <Box sx={{ display: { xs: "flex", md: "flex" } }}>
                <SearchBox
                  onSearch={onSearch}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      const query = {
                        searchTerm: searchTerm,
                        page: currentPage,
                        size: itemPerPage,
                      };

                      getScholarshipRequests(query, setTotalRecods, setLoader);
                    }
                  }}
                  placeholder="Search…"
                />
              </Box>
            </Toolbar>
          </AppBar>
          <div
            style={{
              backgroundColor: "#f3f4f6",
              borderRadius: "0.5rem",
              boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
              MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
              height: "59vh",
              overflowY: "auto",
            }}
            className="px-3"
          >
            {!!scholarshipRequests.length && (
              <table className="table table-striped table-hover   fixTableHead">
                <thead>
                  <tr style={{ backgroundColor: "#f0f2f5" }}>
                    <th scope="col">#</th>
                    <th scope="col" className="text-left">
                      Applicant
                    </th>

                    <th scope="col" className="text-left">
                      Gender
                    </th>

                    <th scope="col" className="text-left">
                      SchoolAttended
                    </th>

                    {/* <th scope="col" className="text-left">
                      Combination
                    </th> */}

                    <th scope="col" className="text-left">
                      GraduationDate
                    </th>

                    <th scope="col" className="text-left">
                      Department of study
                    </th>

                    <th scope="col" className="text-left">
                      RequestedOn
                    </th>

                    {/* <th scope="col" className="text-center" >
                      Transcript Results
                    </th> */}

                    <th scope="col" className="text-right">
                      Status
                    </th>

                    <th scope="col" className="text-right"></th>
                  </tr>
                </thead>

                <tbody>
                  {scholarshipRequests.map((request) => (
                    <ConnectedItemCard
                      key={request.no}
                      request={request}
                      user={user}
                      loading={loading}
                      setShowFormDialog={setShowFormDialog}
                      deleteScholarshipRequest={deleteScholarshipRequest}
                      approveOrRejectScholarshipRequest={
                        approveOrRejectScholarshipRequest
                      }
                      env={env}
                      hasPermissions={hasPermissions}
                    />
                  ))}
                </tbody>
              </table>
            )}

            {!scholarshipRequests?.length && (
              <div className="jumbotron jumbotron-fluid text-center">
                <div className="container py-5 ">
                  <p className="lead">
                    {loading ? "Fetching data..." : "No request made"}{" "}
                  </p>
                </div>
              </div>
            )}
          </div>
          {!!scholarshipRequests.length && (
            <div
              className="d-flex justify-content-center  align-items-center"
              style={{ overflow: "hidden" }}
            >
              <>
                <div className="mt-3">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel={
                      <>
                        <span className="pr-1 d-none d-md-inline">Next</span>
                        <i className="fas fa-angle-double-right"></i>
                      </>
                    }
                    previousLabel={
                      <>
                        <i className="fas fa-angle-double-left"></i>
                        <span className="pl-1  d-none d-md-inline">
                          Previous
                        </span>
                      </>
                    }
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageClick}
                    pageCount={Math.ceil(totalRecods / itemPerPage)}
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
                    previousLinkClassName="btn btn-outline-dark btn-sm mr-1 ml-1"
                    nextLinkClassName="btn btn-outline-dark btn-sm ml-1"
                    activeLinkClassName="active"
                  />
                </div>

                <select
                  className="custom-select custom-select-sm mr-3 ml-2"
                  style={{ width: "100px" }}
                  value={itemPerPage}
                  onChange={(event) => {
                    const itemPerPage = +event.target.value;
                    window.localStorage.setItem("ITEM_PER_PAGE", itemPerPage);
                    setItemPerPage(itemPerPage);
                    const query = {
                      searchTerm: searchTerm,
                      page: currentPage,
                      size: itemPerPage,
                    };
                    getScholarshipRequests(query, setTotalRecods, setLoader);
                  }}
                >
                  {[10, 50, 100, 150].map((item, index) => (
                    <option key={index}>{item}</option>
                  ))}
                </select>
              </>
            </div>
          )}
        </div>
      </div>

      {loader && (
        <CircularProgress
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            color: "rgb(7, 142, 206)",
            position: "absolute",
            top: "42%",
            left: "50%",
            marginTop: "-12px",
            marginLeft: "-12px",
          }}
          size={40}
          thickness={4}
        />
      )}

      {showFormDialog && (
        <AddOrUpdateScholarshipRequestDialog
          showDialog={showFormDialog}
          setShowDialog={setShowFormDialog}
        />
      )}

      {showScholarshipSummary && (
        <ScholarshipSummaryDialog
          showDialog={showScholarshipSummary}
          setShowDialog={setShowScholarshipSummary}
          executed={
            scholarshipRequests.find(
              ({ statusId }) => !![3, 5].includes(statusId)
            ) ||
            // TEMPORARY, scoped to the 2025/2026 REB round only: this round
            // is publishing the shortlist directly (Shortlisted/Not
            // Shortlisted) without running the marks-based selection
            // algorithm, since exam marks aren't available at this stage
            // for this round. Remove once this round has been published.
            (Number(user?.selectedAcademicYear?.id) === 2526 &&
              user?.selectedScope?.id === "REB" &&
              scholarshipRequests.find(
                ({ statusId }) => !![2, 4].includes(statusId)
              ))
          }
        />
      )}

      {confirmExecute && (
        <ConfirmationDialog
          confirmationDialog={confirmExecute}
          message="Are you sure you want to excute scholarship algorithm?"
          setConfirmationDialog={setConfirmExecute}
          onYes={() => {
            executeScholarshipAlgorithm(setConfirmExecute);
          }}
        />
      )}
    </>
  );
};

const ItemCard = (props) => {
  const {
    loading,
    user,
    request,
    setShowFormDialog,
    approveOrRejectScholarshipRequest,
    deleteScholarshipRequest,
    getScholarshipRequestLogs,
    getScholarshipRequests,
    scholarshipRequestLogs,
    submitScholarshipAppeal,
    checkScholarshipAppeal,
    scholarshipAppealSettings,
    env,
    hasPermissions,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const [showPreviewProfileDialog, setShowPreviewProfileDialog] =
    useState(false);

  const [statusId, setStatusId] = useState(null);
  const [statusComment, setStatusComment] = useState("");
  const [showStatusComment, setShowStatusComment] = useState(false);

  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [showCriteriaDialog, setShowCriteriaDialog] = useState(false);

  const [
    showPreviewScholarshipRequestDialog,
    setShowPreviewScholarshipRequestDialog,
  ] = useState(false);

  const [showAppealDialog, setShowAppealDialog] = useState(false);
  const [appealReason, setAppealReason] = useState("");
  const [submittingAppeal, setSubmittingAppeal] = useState(false);
  const [showAppealSuccess, setShowAppealSuccess] = useState(false);
  const [hasExistingAppeal, setHasExistingAppeal] = useState(false);
  const [checkingAppealStatus, setCheckingAppealStatus] = useState(false);

  useEffect(() => {
    if (
      [4].includes(request.statusId) &&
      user?.selectedEntity?.role === "TEACHER" &&
      user?.selectedScope?.id === "REB"
    ) {
      setCheckingAppealStatus(true);
      checkScholarshipAppeal(request.id, (result) => {
        setHasExistingAppeal(!!result.hasAppeal);
        setCheckingAppealStatus(false);
      });
    }
  }, [request.id, user?.selectedEntity?.role, user?.selectedScope?.id]);

  useEffect(() => {
    if (showStatusComment && [4].includes(request.statusId)) {
      if (scholarshipRequestLogs && scholarshipRequestLogs.length > 0) {
        const rejectionLogs = scholarshipRequestLogs.filter((log) =>
          [4, 5].includes(log.statusId)
        );

        if (rejectionLogs.length > 0) {
          const latestLog = rejectionLogs.sort(
            (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
          )[0];

          setStatusComment(latestLog.comment || request.statusComment);
        } else {
          setStatusComment(request.statusComment);
        }
      } else {
        setStatusComment(request.statusComment);
      }
    }
  }, [scholarshipRequestLogs, showStatusComment]);

  const handleAppealSubmit = () => {
    if (!appealReason.trim()) return;

    setSubmittingAppeal(true);

    submitScholarshipAppeal(
      {
        scholarshipRequestId: request.id,
        reason: appealReason,
      },
      () => {
        setShowAppealDialog(false);
        setAppealReason("");
        setSubmittingAppeal(false);
        setShowAppealSuccess(true);
      },
      () => {
        setSubmittingAppeal(false);
      }
    );
  };

  return (
    <>
      <tr>
        <th scope="row" className="text-left">
          {request.no}
        </th>

        <td className="text-left">
          <button
            onClick={() => setShowPreviewProfileDialog(true)}
            className="btn btn-link btn-sm px-0 py-0 text-uppercase text-left text-underline font-weight-bold"
          >
            {request.lastName} {request.firstName}{" "}
            {request.requestedBy === user.id && (
              <span className="badge badge-primary">Me</span>
            )}
          </button>
          <div>
            {request.positionName} ({request.qualificationLevelName}) <br />
            <span className="text-primary font-weight-bold">
              @{request.schoolName} <i className="fas fa-chevron-right"></i>{" "}
              {request.sectorName} / {request.districtName}
            </span>
          </div>
        </td>

        <td className="text-left">{request.gender}</td>
        <td className="text-left">
          <div>
            <span className="text-primary font-weight-bold text-uppercase">
              {request.attendedSchoolName}
            </span>{" "}
            <br />
            {request.combinationName}
          </div>
        </td>
        <td className="text-left">
          {moment(request.graduationDate).format("MMMM YYYY")}
        </td>

        <td className="text-left">{request.scholarshipCourseName}</td>

        <td className="text-left">{moment(request.createdOn).format("lll")}</td>

        <td className="text-right">
          <span className="d-flex align-items-center justify-content-end">
            <span
              className={`text-uppercase badge badge-${
                [2, 3].includes(request.statusId)
                  ? "success"
                  : [4, 5].includes(request.statusId)
                  ? "danger"
                  : [7].includes(request.statusId)
                  ? "warning"
                  : [1].includes(request.statusId)
                  ? "secondary"
                  : "primary"
              } `}
            >
              {request.statusName}
            </span>

            {[4].includes(request.statusId) &&
              user?.selectedEntity?.role === "TEACHER" && (
                <IconButton
                  size="small"
                  className="ml-1"
                  color="error"
                  onClick={() => {
                    getScholarshipRequestLogs(request.id);
                    setShowStatusComment(true);
                  }}
                >
                  <span className="material-icons">error</span>
                </IconButton>
              )}

            {[3, 7].includes(request.statusId) && (
              <IconButton
                size="small"
                className="ml-1 mb-1"
                color="primary"
                onClick={() => setShowCriteriaDialog(true)}
              >
                <span className="material-icons">info</span>
              </IconButton>
            )}

            {[4].includes(request.statusId) &&
              user?.selectedEntity?.role === "TEACHER" &&
              user?.selectedScope?.id === "REB" &&
              !hasExistingAppeal &&
              isAppealWindowOpen(scholarshipAppealSettings) && (
              <Button
                size="small"
                variant="contained"
                color="info"
                className="ml-2"
                onClick={() => setShowAppealDialog(true)}
                title="Submit appeal"
                disabled={checkingAppealStatus}
              >
                {checkingAppealStatus ? (
                  <CircularProgress size={16} color="inherit" />
                ) : (
                  <span style={{ fontSize: "0.75rem", fontWeight: "bold" }}>
                    Appeal
                  </span>
                )}
              </Button>
            )}
          </span>
        </td>

        <td className="text-right">
          <IconButton onClick={handleOpenMenu}>
            <Badge color="info">
              <span className="material-icons">more_vert</span>
            </Badge>
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleCloseMenu}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 2,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 15,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <span>
              <MenuItem
                onClick={() => {
                  handleCloseMenu();
                  setShowPreviewScholarshipRequestDialog(true);
                }}
                className="text-primary font-weight-bolder"
              >
                <span className="material-icons mr-1">open_in_new</span>
                Preview
              </MenuItem>
              <Divider className="my-1" />
            </span>

            {((user.id === request.teacherId && request.statusId === 1) ||
              hasPermissions(["SCHOLARSHIPS_REMOVE"])) && (
              <span>
                <MenuItem
                  onClick={(e) => {
                    handleCloseMenu();
                    setShowConfirmDelete(true);
                  }}
                  className="text-danger"
                >
                  <span className="material-icons mr-1">delete</span>
                  Remove
                </MenuItem>
              </span>
            )}
          </Menu>
        </td>
      </tr>

      {showStatusComment && (
        <AlertDialog
          maxWidth="sm"
          showAlert={showStatusComment}
          setShowAlert={setShowStatusComment}
        >
          {loading ? (
            <div className="text-center p-3">
              <CircularProgress size={24} />
              <p className="mt-2">Loading reason...</p>
            </div>
          ) : (
            <>
              <h6 className="text-primary font-weight-bold">Reason</h6>
              <div className="p-3 mt-2 bg-light border rounded">
                {statusComment || (
                  <div className="text-center p-3">
                    <CircularProgress size={24} />
                    <p className="mt-2">Loading reason...</p>
                  </div>
                )}
              </div>
            </>
          )}
        </AlertDialog>
      )}

      {!!showConfirmDelete && (
        <ConfirmationDialog
          confirmationDialog={showConfirmDelete}
          message={
            <>
              <p className="mt-2">
                Are you sure you want to{" "}
                <strong className={`text-danger`}>delete</strong> this
                scholarship request?
              </p>
            </>
          }
          setConfirmationDialog={setShowConfirmDelete}
          onYes={() => {
            deleteScholarshipRequest(request.id, () =>
              setShowConfirmDelete(false)
            );
          }}
        />
      )}

      {showPreviewScholarshipRequestDialog && (
        <PreviewScholarshipRequestDialog
          showDialog={showPreviewScholarshipRequestDialog}
          setShowDialog={setShowPreviewScholarshipRequestDialog}
          request={request}
        />
      )}

      {showPreviewProfileDialog && (
        <PreviewTeacherProfile
          showDialog={showPreviewProfileDialog}
          setShowDialog={setShowPreviewProfileDialog}
          teacherId={request.teacherId}
        />
      )}

      {showCriteriaDialog && (
        <ScholarshipCriteriaDialog
          showDialog={showCriteriaDialog}
          setShowDialog={setShowCriteriaDialog}
        />
      )}

      {showAppealDialog && (
        <AlertDialog
          title="Appeal for Scholarship Request"
          maxWidth="md"
          showAlert={showAppealDialog}
          setShowAlert={(value) => {
            if (!submittingAppeal) {
              setShowAppealDialog(value);
            }
          }}
          actions={
            <div className="d-flex justify-content-end w-100">
              <Button
                color="inherit"
                onClick={() => !submittingAppeal && setShowAppealDialog(false)}
                disabled={submittingAppeal}
                className="mr-2"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleAppealSubmit}
                disabled={
                  !appealReason.trim() ||
                  submittingAppeal ||
                  appealReason.length > 1000
                }
                style={{
                  minWidth: "150px",
                  fontWeight: "bold",
                  backgroundColor: "#1976d2",
                  color: "white",
                }}
              >
                {submittingAppeal ? (
                  <>
                    <CircularProgress
                      size={20}
                      color="inherit"
                      className="mr-2"
                    />
                    Submitting...
                  </>
                ) : (
                  <>
                    <span className="material-icons mr-1">send</span>
                    Submit Appeal
                  </>
                )}
              </Button>
            </div>
          }
        >
          <>
            <div className="mb-3">
              <Typography variant="body2">
                The Ministry of Education invites you to submit any additional
                information that may support reconsideration of your
                application. Please provide reasons why your application should
                be reconsidered.
              </Typography>
            </div>
            <TextField
              autoFocus
              fullWidth
              multiline
              rows={8}
              variant="outlined"
              label="Appeal Reason"
              placeholder="Enter your appeal reason here..."
              value={appealReason}
              onChange={(e) => {
                if (e.target.value.length <= 1000) {
                  setAppealReason(e.target.value);
                }
              }}
              inputProps={{
                maxLength: 1000,
              }}
              disabled={submittingAppeal}
              required
              helperText={`${appealReason.length}/1000 characters`}
              FormHelperTextProps={{
                style: {
                  textAlign: "right",
                  marginRight: "8px",
                  color:
                    appealReason.length >= 950
                      ? appealReason.length >= 1000
                        ? "red"
                        : "orange"
                      : "inherit",
                },
              }}
            />
          </>
        </AlertDialog>
      )}

      {showAppealSuccess && (
        <AlertDialog
          maxWidth="xs"
          showAlert={showAppealSuccess}
          setShowAlert={(value) => {
            setShowAppealSuccess(value);
            if (!value) {
              window.location.reload();
            }
          }}
          actions={
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setShowAppealSuccess(false);
                window.location.reload();
              }}
              className="px-4"
            >
              Close
            </Button>
          }
        >
          <div className="text-center py-3">
            <span
              className="material-icons text-success"
              style={{ fontSize: "48px" }}
            >
              check_circle
            </span>
            <Typography variant="h6" className="mt-2 mb-3">
              Appeal Submitted Successfully
            </Typography>
            <Typography variant="body2">
              Your appeal has been submitted and will be reviewed by the
              committee. You will be notified about the decision in due time.
            </Typography>
          </div>
        </AlertDialog>
      )}
    </>
  );
};

const ConnectedItemCard = connect(
  ({
    loading,
    scholarshipRequestLogs,
    scholarshipRequests,
    scholarshipAppealSettings,
  }) => ({
    loading,
    scholarshipRequestLogs,
    scholarshipRequests,
    scholarshipAppealSettings,
  }),
  {
    getScholarshipRequestLogs,
    submitScholarshipAppeal,
    getScholarshipRequests,
    checkScholarshipAppeal,
  }
)(ItemCard);

const mapStateToProps = ({
  env,
  user,
  loading,
  scholarshipCombinations,
  scholarshipCourses,
  scholarshipDocuments,
  scholarshipRequests,
  districts,
  scholarshipSchedule,
}) => {
  return {
    env,
    user,
    loading,
    scholarshipCombinations,
    scholarshipCourses,
    scholarshipDocuments,
    scholarshipRequests,
    districts,
    scholarshipSchedule,
  };
};

export default connect(mapStateToProps, {
  getScholarshipCombinations,
  getScholarshipCourses,
  getScholarshipDocuments,
  getScholarshipRequests,
  deleteScholarshipRequest,
  approveOrRejectScholarshipRequest,
  getDistricts,
  getEligibility,
  executeScholarshipAlgorithm,
  getScholarshipSchedule,
  getScholarshipAppealSettings,
})(Scholarships);
